import React from 'react';
import { Container } from './styles';
import TitleBanner from '../TitleBanner';
import Button from '../Button';
import VerificationImage from '../../images/email-verification.png';

const ConfirmationScreen = props => {
  const { content, title, onClick, img, alt, buttonLabel } = props;

  return (
    <Container>
      <TitleBanner title={title} />
      <p className="info"> {content} </p>
      <img
        className="image"
        src={img ? img : VerificationImage}
        alt={alt}
      />
      <Button label={buttonLabel} onClick={onClick} />
    </Container>
  );
};

export default ConfirmationScreen;
